import type { ReactNode } from 'react';
import { SizableText, XStack } from 'tamagui';

interface KeyValueRowProps {
  label: string;
  value?: ReactNode;
  fallback?: string;
}

export const KeyValueRow = ({
  label,
  value,
  fallback = '...',
}: KeyValueRowProps): React.ReactElement => {
  const displayValue = !value ? fallback : value;

  return (
    <XStack gap="$true" justifyContent="space-between" alignItems="flex-start">
      <SizableText color="$secondary75" flex={1} size="$2">
        {label}
      </SizableText>
      <SizableText color="$secondary" flex={1} size="$2" textAlign="right">
        {displayValue}
      </SizableText>
    </XStack>
  );
};
